import Activity from './activity';
import Auth from './auth';
import Gateway from './gateway';
import Partner from './partner';
import Profile from './profile';
import QRCode from './qrcode';
import SIGAM from './SIGAM';
import System from './system';
import Wallet from './wallet';

const Request = {
  Activity,
  Auth,
  Gateway,
  Partner,
  Profile,
  QRCode,
  SIGAM,
  System,
  Wallet
};

export default Request;
